import { TriangleAlert } from 'lucide-react';

import { useMe } from '../../hooks';
import styles from './CrmLinkWarning.module.css';

export function CrmLinkWarning() {
  const { data: session } = useMe();
  if (!session?.crm_link_warning) return null;

  return (
    <div className={styles.banner} role="alert">
      <TriangleAlert size={15} strokeWidth={1.5} />
      Свяжитесь с администратором: логин не найден в CRM
    </div>
  );
}
